import React from 'react';
import { locales } from '../../translations/locales';

const ModalSocketError = (props) => {
    const { locale } = props;

    return (
        <div>
            <div
                className="modal"
                id="modalSocket"
                data-backdrop="static"
                data-keyboard="false"
                tabIndex="-1"
                aria-labelledby="modalTitle"
                aria-hidden="true"
            >
                <div className='modal-dialog modal-dialog-scrollable modal-dialog-centered'>
                    <div className='modal-content'>
                        <div className='modal-header'>
                            <h5 className='modal-title' id='modalSocket-Title'>{locales[locale].modals.connectionError.title}</h5>
                        </div>
                        <div className='modal-body text-center' id='modalSocket-body'></div>
                        <div className='modal-footer' id='modalSocket-footer'></div>
                    </div>
                </div>
            </div>
        </div>
    );
};

export default ModalSocketError;
